module.exports = __webpack_public_path__ + "static/media/horizontal-scroll.ae285d07.svg";